import { Component } from '@angular/core';

@Component({
  selector: 'app-receipt-cancellationlink',
  templateUrl: './receipt-cancellationlink.component.html',
  styleUrls: ['./receipt-cancellationlink.component.scss']
})
export class ReceiptCancellationlinkComponent {

}
